export enum SearchMode {
  simple,
  advanced
};